const PRIVILEGES: Record<string, number> = {
  creator: 1 << 0,
  // edit: 1 << 1,
  // delete: 1 << 2,
  // manage: 1 << 3,
  // admin: 1 << 4,
};

export type PrivilegeName = keyof typeof PRIVILEGES;

export function hasPrivilege(privileges: number, name: PrivilegeName): boolean {
  if (name === "creator") return true; //// give all users access to creator books for now, until future notice.
  return (privileges & PRIVILEGES[name]) === PRIVILEGES[name];
}
